import {http} from "@/http/ai-http";
import {aiConfig as getAiConfig} from '@/api/constantApi.js'

export type AiConfig = {
    authCode: string,
    name: string,
    open: boolean
}

export async function aiConfig() {
   return getAiConfig() as AiConfig
}
